import type { ApiListingApplicationId } from 'api/types/ApiTypedId';
import { del } from 'utils/http/del';

export async function userDashboardApiDeleteListingApplication(
  applicationId: ApiListingApplicationId,
) {
  return del(`/data/listing-applications/${applicationId}`);
}
